import i18n, { InitOptions } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { configManager } from '../../../../config/configManager'

// @lat: [[i18n#Translation load]]
export const initI18n = async (language: string): Promise<void> => {
  if (i18n.isInitialized) {
    await i18n.changeLanguage(language)
    return
  }

  console.log('init I18n: ' + language)
  await i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      lng: language,
      fallbackLng: 'en',
      debug: false,
      ns: ['e-commander-common', 'e-commander-settings', 'e-commander-multiple-locale'],
      defaultNS: 'e-commander-common',
      fallbackNS: 'e-commander-common',
      load: 'languageOnly',
      nsSeparator: ':',
      interpolation: {
        escapeValue: false,
      },
      backend: {
        // Use i18next placeholders so namespace/language resolve correctly for every request.
        loadPath: `${configManager.api.GATEWAY_URL}/locale/{{lng}}/{{ns}}`,
      },
      react: {
        useSuspense: true,
      },
    } as InitOptions)
}

export default i18n
